import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ImportMappedProjectService {

  constructor(private rest: RestService) { }

  public getPMProjectListAgile(option: string) {
    let payload = {
      "project_management_type": option,
      "cloudId": "",
      "startAt": "0",
      "maxResult": "10"
    }
    return this.rest.post('getPMProjectList', payload, null);
  }

  public importAllMappedProject(data: any, licenseId: string) {
    let payload = {
      "licenseId": licenseId,
      "projectMapping": {
        "project_management_project_id": data.project_management_project_id,
        "projectName": data.projectName,
        "project_management_project_key": data.project_management_project_key,
        "project_management_type": data.project_management_type,
        "project_style":data.project_style
      }
    }
    return this.rest.post('importAllPMProject', payload, null);
  }

  public getPMProjectList(cloudId: string, type: string) {
    let payload = {
      "project_management_type": type,
      "cloudId": cloudId,
      "startAt": "0",
      "maxResult": "10"
    }
    return this.rest.post('getPMProjectList', payload, null);
  }

  public importSelectiveMappedProject(data: any) {
    let payload = {
      "projectMapping": {
        "project_management_project_id": data.project_management_project_id,
        "projectName": data.projectName,
        "project_management_project_key": data.project_management_project_key,
        "project_style": data.project_style,
        "projectTypeKey": "software",
        "project_management_type": data.project_management_type
      },
      "size": 10,
      "page": 1
    }
    return this.rest.post('selectiveImportProject', payload, null);
  }

  public childSelect(data, data1) {
     let projectId = localStorage.getItem("projectId")||'';
    let payload = {
      "projectManagementProjectId": data1.project_management_project_id,
      "projectId":projectId == null ? "": projectId ,
      "projectStyle": data1.project_style,
      "artifactId": data.epic_id,
      "artifactType": data._type,
      "project_management_type": data1.project_management_type
    }
    return this.rest.post('childListShowSelective', payload, null);
  }

  public childSelectfeature(data, data1) {
     let projectId = localStorage.getItem("projectId");
    let payload = {
      "projectManagementProjectId": data1.project_management_project_id,
      "projectId":projectId == null ? "": projectId ,
      "projectStyle": data1.project_style,
      "artifactId": data.issue_id,
      "artifactType": data.issue_type,
      "project_management_type": data1.project_management_type
    }
    return this.rest.post('childListShowSelective', payload, null);
  }

  public childSelectscenario(data, data1) {
    let projectId = localStorage.getItem("projectId");
    let payload = {
      "projectManagementProjectId": data1.project_management_project_id,
      "projectId":projectId == null ? "": projectId ,
      "projectStyle": data1.project_style,
      "artifactId": data.issue_id,
      "artifactType": data.issue_type,
      "project_management_type": data1.project_management_type
    }
    return this.rest.post('childListShowSelective', payload, null);
  }

  public allSelectiveImport(payload) {
    return this.rest.post('selectiveImport', payload, null);
  }

  public updateProjectItems(projectId:string){
    return this.rest.get('updateProjectItems',projectId);
  }
  //jira project assign to user

  public getOrgAccNo() {
    return this.rest.get('getOrgAccNo', null);
  }

  public getOrgAccUsers(accNo: number, accountId: string) {
    return this.rest.get('getOrgAccUsers',  accNo, accountId );
  }

  public assignJiraProjectToUser(users: string[]) {
    const projectId = localStorage.getItem("projectId");
    const payload = {
      projectIds: [projectId],
      userNames: users
    };
    return this.rest.post('assignJiraProjectToUser', payload, null);

  }

  public syncAccountProject(payload){
    return this.rest.post("importAccountProjects", payload , null);
  }

}
